import React from 'react';

const ThemeRenderIntro = (props) => {
    const { fields } = props;

    return (
        <div className="work__intro">
            <p className="intro">{fields.work_introtxt}</p>
        </div>
    );
};

export default ThemeRenderIntro;



// WEBPACK FOOTER //
// ./src/components/Pages/Themes/ThemeRenderIntro.jsx